import React from 'react'

const NotFound = () => {
  return <div>Nothing Here</div>
}

export default NotFound
